module.exports = __webpack_public_path__ + "static/img/btn-animate-start.4913fa42.png";